var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92737 2.18179C3.92737 1.86046 4.18786 1.59998 4.50919 1.59998H11.491C11.8123 1.59998 12.0728 1.86046 12.0728 2.18179V6.25452C12.0728 6.57585 11.8123 6.83634 11.491 6.83634C11.1697 6.83634 10.9092 6.57585 10.9092 6.25452V2.76361H5.09101V6.25452C5.09101 6.57585 4.83052 6.83634 4.50919 6.83634C4.18786 6.83634 3.92737 6.57585 3.92737 6.25452V2.18179Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.34555 6.83634C3.19124 6.83634 3.04326 6.89764 2.93414 7.00675C2.82503 7.11586 2.76373 7.26385 2.76373 7.41816V10.3272C2.76373 10.4816 2.82503 10.6295 2.93414 10.7387C3.04326 10.8478 3.19124 10.9091 3.34555 10.9091H4.50919C4.83052 10.9091 5.09101 11.1696 5.09101 11.4909C5.09101 11.8122 4.83052 12.0727 4.50919 12.0727H3.34555C2.88263 12.0727 2.43867 11.8888 2.11133 11.5615C1.78399 11.2341 1.6001 10.7902 1.6001 10.3272V7.41816C1.6001 6.95523 1.78399 6.51127 2.11133 6.18393C2.43867 5.8566 2.88263 5.6727 3.34555 5.6727H12.6546C13.1176 5.6727 13.5615 5.8566 13.8889 6.18393C14.2162 6.51127 14.4001 6.95523 14.4001 7.41816V10.3272C14.4001 10.7902 14.2162 11.2341 13.8889 11.5615C13.5615 11.8888 13.1176 12.0727 12.6546 12.0727H11.491C11.1697 12.0727 10.9092 11.8122 10.9092 11.4909C10.9092 11.1696 11.1697 10.9091 11.491 10.9091H12.6546C12.8089 10.9091 12.9569 10.8478 13.066 10.7387C13.1752 10.6295 13.2365 10.4816 13.2365 10.3272V7.41816C13.2365 7.26385 13.1752 7.11586 13.066 7.00675C12.9569 6.89764 12.8089 6.83634 12.6546 6.83634H3.34555Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92737 9.16361C3.92737 8.84228 4.18786 8.58179 4.50919 8.58179H11.491C11.8123 8.58179 12.0728 8.84228 12.0728 9.16361V13.8182C12.0728 14.1395 11.8123 14.4 11.491 14.4H4.50919C4.18786 14.4 3.92737 14.1395 3.92737 13.8182V9.16361ZM5.09101 9.74543V13.2363H10.9092V9.74543H5.09101Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintIcon);
export default __webpack_public_path__ + "static/media/print_icon.857857ba70482e3aa47cde5ed6fb0033.svg";
export { ForwardRef as ReactComponent };